module.exports = __webpack_public_path__ + "img/active-null.ce0b6a23.svg";